/*! @azure/msal-browser v3.17.0 2024-06-10 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.17.0";

export { name, version };
